import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableSelectComponent } from './table-select.component';
import {FormsModule} from "@angular/forms";
import {JdSelectModule} from "../select/jd-select.module";
@NgModule({
  imports: [
    CommonModule,
    JdSelectModule,
    FormsModule
  ],
  declarations: [
    TableSelectComponent
  ],
  exports: [
    TableSelectComponent
  ]
})
export class JdSelectTableModule {}
